import React from "react";
import Checkbox from "@mui/material/Checkbox";
import { useInterestsTable } from "./table-context";

const SelectRow: React.FC<{id: string}> = (props) => {
  const { selectedInterestIds, toggleSelectionId } = useInterestsTable();
  return (
    <Checkbox
      data-component="SelectRowCheckbox"
      data-rid={props.id}
      size="small"
      checked={selectedInterestIds.indexOf(props.id as never) !== -1}
      onChange={(event) => toggleSelectionId(props.id, event.target.checked)}
    />
  );
};

export default SelectRow;
